<template>
  <div :class="isWideScreen ? 'whole-wrap whole-wrap--measure-explanation-pc ' : 'whole-wrap whole-wrap--measure-explanation'">
    <BurgerMenuComponentPC
    v-if="isWideScreen"
    @cancel="endMeasure"
    :isExplanationLeft="true"
    :isExplanationRight="true"
    :isTitle="$t('patk_test.title')"
    :isTimer="measureCount"
    :isAnalysis="analysisTypeFlag === '2'"
    :isUseAnalaysis="useAnalaysisFlag"
    />
    <div class="measure">

      <div v-show="!isWideScreen" class="measure-title">{{ $t('patk_test.title') }}</div>
      <div v-show="!isMeasure.isReady">
        <div v-if="isWideScreen">
          <div :class="['pc-measure-subject', `pc-measure-subject--${$route.params.measureWord}`]">
          </div>
          <div class="pc-item" style="padding: 37px 19px 0px 48px;">
            <div class="pc-item-text" v-html="$t('patk_test.instruction', { measureWordText, measureCount })">
            </div>
            <div class="pc-item-woman-img"></div>
          </div>
          <div class="flex justify-content-center mt-32">
            <div class="measure-start-text" v-html="$t('patk_test.ready')">
            </div>
          </div>
          <div class="flex justify-content-center mt-17">
            <div class="btn btn-base-pc" @click="startMeasure">{{ $t('patk_test.start', { measureCount }) }}</div>
          </div>
        </div>

        <div v-else>
          <div :class="['measure-subject', `measure-subject--${$route.params.measureWord}`]">
          </div>
          <div class="flex justify-content-center mt-7">
            <div class="time-info">
              <div class="time-info-icon"></div>
              <div class="time-info-text">{{ measureCount }}<span class="time-info-text-unit">{{ $t('settings.seconds_suffix') }}</span></div>
            </div>
            <div v-if="useAnalaysisFlag" class="save-info ml-40">
              <div class="voice-info-icon" :class="analysisTypeFlag === '2'?'voice-info-icon--on':'voice-info-icon--off'"></div>
              <div class="save-info-text">{{analysisTypeFlag === '2'?$t('patk_test.clarity_on'):$t('patk_test.clarity_off')}}</div>
            </div>
          </div>
          <div class="measure-woman-img"></div>
          <div class="measure-explanation-text" v-html="$t('patk_test.instruction', { measureWordText, measureCount })">
          </div>
          <div class="flex justify-content-center mt-88">
            <div class="measure-start-text" v-html="$t('patk_test.ready')">
            </div>
          </div>
          <div class="flex justify-content-center mt-16">
            <div class="btn btn-base mt-23" @click="startMeasure">{{ $t('patk_test.start', { measureCount }) }}</div>
          </div>
          <div class="flex justify-content-center mt-16">
            <div class="btn btn-close btn-close--shadow" @click="endMeasure">
              <div class="btn-close-text">{{ $t('test_list.finish') }}</div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="isMeasure.isReady && !isMeasure.isComplete">
        <div class="measure-area">
          <div class="measure-area-text">
            <div v-if="isMeasure.isStart">{{ $t('patk_test.get_ready', { measureWordText }) }}</div>
            <div v-if="isMeasure.isShow || isMeasure.isComplete">{{ $t('patk_test.say', { measureWordText }) }}</div>
          </div>
          <div :class="['measure-area-canvas-wrap', `measure-area-canvas-wrap--${$route.params.measureWord}`]">
            <div class="measure-area-canvas-text">
              <div v-if="!isMeasure.isStart && !isMeasure.isShow && !isMeasure.isEnd">{{ $t('patk_test.now_start') }}</div>
              <div v-if="isMeasure.isEnd">{{ $t('patk_test.end') }}</div>
            </div>
            <div :class="['measure-area-start-count', `measure-area-start-count--count${prepCount}`]" v-if="isMeasure.isStart"></div>
            <!-- プログレスバー -->
            <canvas id="progressCanvas" class="measure-area-canvas" :class="{ 'measure-area-canvas--inactive': !isMeasure.isShow, 'measure-area-canvas--end': isMeasure.isEnd }" width="224" height="224"></canvas>
          </div>
          <div class="measure-area-count" v-if="isMeasure.isShow || isMeasure.isComplete">
            <div class="measure-area-count-rest">{{ $t('patk_test.seconds_left_prefix') }}</div>
            <div class="measure-area-count-time">{{ measureCountCounter }}</div>
            <div class="measure-area-count-unit">{{ $t('patk_test.seconds_left_suffix') }}</div>
          </div>
        </div>
        <div v-show="!isWideScreen" class="flex justify-content-center mt-16">
          <div class="btn btn-close btn-close--shadow" @click="endMeasure">
            <div class="btn-close-text" v-if="!isMeasure.isStart && !isMeasure.isShow && !isMeasure.isComplete">{{ $t('patk_test.stop_test') }}</div>
            <div class="btn-close-text" v-else>{{ $t('test_list.finish') }}</div>
          </div>
        </div>
        <div class="flex justify-content-center mt-16" style="font-size: large" v-if="isComunicate">{{ $t('patk_test.loading') }}</div>
      </div>
      <div v-show="isError">
        <div class="measure-area measure-area--completion">
          <div class="error-text">{{errorMessage}}</div>
          <div class="btn btn-measure-no mt-16" @click="retryMeasure">
            <div class="btn-measure-no-strong-text">{{ !isError ? $t('patk_test.no') : $t('patk_test.retry_measurement') }}</div>
            <div class="btn-measure-no-text" v-if="!isError">{{ $t('patk_test.retry_measurement') }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- コピーライト -->
    <div :class="calculateCopyrightClass()">© 2025 Lion Corporation. All rights reserved.</div>
    <!-- ダイヤログ -->
    <SavingDialog
    v-if="isSaving"
    :isComplete="isComplete"
    />
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import * as circleProgress from './common/circleProgress';
import { startRecording } from './common/audioRecord';
import { analyzeRecordedData } from './common/analyzeRecord';
import { formatDate, formatTime, formatFileData, formatFileName, formatTimeStamp } from './common/dateFormatter';
import { useToast } from 'vue-toast-notification';
import {calculateDtw} from './common/calculateDtw';
import BurgerMenuComponentPC from './BurgerMenuPc.vue';
import 'vue-toast-notification/dist/theme-sugar.css';

import SavingDialog from '@/components/SavingDialog.vue';

export default {
  components: {
    SavingDialog,
    BurgerMenuComponentPC,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const { t } = useI18n();
    const $toast = useToast();

    // PC画面幅管理用
    const isWideScreen = ref(window.innerWidth >= 600);

    const operatorId = router.currentRoute.value.params.operator_id;
    const measurementType = ref(0);
    const analysisTypeFlag = ref(null);
    const audioStorageFlag = ref('');
    const subjectId = ref('');
    const age = ref('');
    const gender = ref('');
    const measureWord = router.currentRoute.value.params.measureWord;
    const startDateTime = ref('');
    const measurementStartTime = ref('');

    const useAnalaysisFlag = ref(false);

    const prepCount = ref(0);
    const measureCount = ref(0);
    const measureCountCounter = ref(0);

    const audioStorageText = ref('');
    const measureWordText = ref('');
    const pronunciation = ref(0);

    const audioId = ref('');
    const audioData = ref(null);
    const measureFileData = ref('');
    const measureFileTime = ref('');
    const audioURL = ref('');

    let countdownTimer;
    let interval;

    const analyzeData = ref(null);
    const wavDataBase64 = ref(null);

    const analysisVocabCount = ref(null); //明瞭度解析のトータル格納用

    const isSaving = ref(false); //ダイヤログ表示フラグ
    const isComplete = ref(false); //ダイヤログ表示内容指定フラグ

    const isMeasure = ref({
      isReady: false,
      isStart: false,
      isShow: false,
      isEnd: false,
      isComplete: false,
    });

    const recordedParam = ref({
      filename: null,
      category: null,
      age: null,
      gender: null,
    });

    const vocabCountSecond = ref(Array(12).fill(0));
    const vocabAnalysisCountSecond = ref(Array(12).fill(0));

    const isComunicate = ref(false);
    const isPermission = ref(false);
    const isCountFinish = ref(false);
    const isAnalyzeAborted = ref(false);
    const isError = ref(false);
    const errorMessage = ref('');

    let countDownCtx = null;
    let measureEndCtx = null;
    let countDownBufferNode = null;
    let measureEndBufferNode = null;
    const countDownAudioPath = {
      ja: '/audio/20250107_countdown_modified.mp3',
      en: '/audio/en/20251206_countdown_en.mp3',
    };
    const measureEndAudioPath = {
      ja: '/audio/終了時音声ガイド.mp3',
      en: '/audio/en/終了時音声ガイド_en.mp3',
    };
    let isPlayCountAudio = false;
    let isPlayMeasureAudio = false;
    const volumeLevel = 0.5;

    // 画面幅設定
      const updateScreenWidth = () => {
      isWideScreen.value = window.innerWidth >= 600;
    };

    // コンポーネントがマウントされたときにデータを取得
    onMounted(() => {
      updateScreenWidth();
      window.addEventListener('resize', updateScreenWidth);
      window.scrollTo(0, 0);
      fetchData();
      requestMediaDevice();
    });

    // コンポーネントがアンマウントされるときに処理を破棄
    onBeforeUnmount(() => {
      // イベントリスナーのクリーンアップ
      window.removeEventListener('resize', updateScreenWidth);

      // 中断フラグをセットして解析処理を中断
      isAnalyzeAborted.value = true;
      // タイマーが存在する場合はクリア
      if (countdownTimer) {
        clearTimeout(countdownTimer);
      }
      // カウントダウン音声の再生を停止
      if (isPlayCountAudio) {
        countDownBufferNode.stop();
        countDownBufferNode.disconnect();
        countDownBufferNode = null;
        isPlayCountAudio = false;
      }
      // 測定終了音声の再生を停止
      if (isPlayMeasureAudio) {
        measureEndBufferNode.stop();
        measureEndBufferNode.disconnect();
        measureEndBufferNode = null;
        isPlayMeasureAudio = false;
      }
      // オーディオコンテキストを解放
      if (countDownCtx) {
        countDownCtx.close();
        countDownCtx = null;
      }
      if (measureEndCtx) {
        measureEndCtx.close();
        measureEndCtx = null;
      }

      clearInterval(interval);

      // マイクが保持しているリソースを明示的に解放
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          if (stream) {
            stream.getTracks().forEach((track) => track.stop());
          }
        })
        .catch((error) => {
          console.error('マイクの利用に失敗しました。', error);
        });
    });

    // 再生用音声データの読み込み準備処理
    const prepareAudio = async () => {
      // ユーザーのボタンクリック時にオーディオを生成
      countDownCtx = new (window.AudioContext || window.webkitAudioContext)();
      measureEndCtx = new (window.AudioContext || window.webkitAudioContext)();

      const savedLocale = localStorage.getItem('app-locale') || 'ja';
      // 音声データを読み込み再生準備を行う
      countDownBufferNode = await createBufferNode(countDownCtx, countDownAudioPath[savedLocale]);
      measureEndBufferNode = await createBufferNode(measureEndCtx, measureEndAudioPath[savedLocale]);
    };

    // 音声データ再生用のオブジェクトを取得
    const createBufferNode = async (context, audioPath) => {
      const response = await fetch(audioPath);
      const responseBuffer = await response.arrayBuffer();
      // 音声データをバッファーに登録
      const bufferNode = context.createBufferSource();
      bufferNode.buffer = await context.decodeAudioData(responseBuffer);
      // gainNodeにアプリ音量を設定
      const gainNode = context.createGain();
      gainNode.gain.value = volumeLevel;
      // 出力先データに接続
      bufferNode.connect(gainNode);
      gainNode.connect(context.destination);

      return bufferNode;
    };

    // ストアからデータを取得して画面の初期化
    const fetchData = () => {
      // ストアから各種データを取得
      measurementType.value = store.getters['dataManagement/getMeasurementType'];
      audioStorageFlag.value = store.getters['dataManagement/getAudioStorageFlag'];
      subjectId.value = store.getters['dataManagement/getSubjectId'];
      age.value = store.getters['dataManagement/getAge'];
      gender.value = store.getters['dataManagement/getGender'];
      startDateTime.value = store.getters['dataManagement/getStartDateTime'];
      analysisTypeFlag.value = store.getters['dataManagement/getAnalysisTypeFlag'];
      useAnalaysisFlag.value = store.getters['dataManagement/getisUseAnalaysis'];

      // 画面表示に使用するデータの初期化
      prepCount.value = 3;
      measureCountCounter.value = measureCount.value = parseInt(measurementType.value === '1' ? 5 : 10);
      audioStorageText.value = audioStorageFlag.value === '0' ? '保存する' : '保存しない';


      // 測定単語による表示切替
      switch (measureWord) {
        case 'pa':
          measureWordText.value = t('test_list.patk_label_pa');
          pronunciation.value = 1;
          break;
        case 'ta':
          measureWordText.value = t('test_list.patk_label_ta');
          pronunciation.value = 2;
          break;
        case 'ka':
          measureWordText.value = t('test_list.patk_label_ka');
          pronunciation.value = 3;
          break;
        default:
          measureWordText.value = '';
          pronunciation.value = 0;
      }

      // オーディオファイル名の生成
      measureFileData.value = formatFileData(new Date());
      measureFileTime.value = formatFileName(new Date());
      audioId.value = `${subjectId.value}_${measureWord}_${measureFileTime.value}.wav`;
    };

    // 適用クラスの選択処理
    const calculateCopyrightClass = () => {
      if (!isMeasure.value.isReady) {
        return 'text-copyright';
      } else if (isMeasure.value.isReady && !isMeasure.value.isComplete) {
        return 'text-copyright-measure';
      } else if (isMeasure.value.isReady && isMeasure.value.isComplete) {
        return 'text-copyright-complete';
      }
    };

    // マイクの使用権限をリクエストする処理
    const requestMediaDevice = async () => {
      try {
        if (!isPermission.value) {
          await navigator.mediaDevices.getUserMedia({ audio: true });
          // マイクの使用権限が許可されたときの処理
          isPermission.value = true;
        } else {
          // マイクの使用権限が拒否されたときの処理
          isPermission.value = false;
          window.confirm(t('errors.microphone_permission_required'));
        }
      } catch (err) {
        window.confirm(t('errors.microphone_access_failed'), err);
      }
    };

    // 測定開始処理
    const startMeasure = async () => {
      //計測開始時間の保存
      measurementStartTime.value = formatTimeStamp(new Date());

      window.scrollTo(0, 0);
      await prepareAudio();
      // マイクの使用許可を確認
      if (!isPermission.value) {
        requestMediaDevice();
      } else {
        // カウントダウン音声の再生
        countDownBufferNode.start(0);
        isPlayCountAudio = true;
        // 測定の準備ができたフラグをセット
        isMeasure.value.isReady = true;
        // 円形進捗バーを実行
        runCircleProgress();
        // 準備時間終了後の処理を予約
        countdownTimer = setTimeout(startPrepCountdown, 3500);
      }
    };

    // 測定終了処理
    const endMeasure = async () => {
      // メニュー選択画面に遷移
      router.push({
        name: 'selectMenu',
        params: {
          operator_id: operatorId,
        },
      });
    };

    // 音声と検査結果を保持する処理
    const registMeasure = async () => {
      try {
        if (!isError.value) {
          // 録音音声をS3に保存
          await setAudioToS3();

          // 検査結果をストアに保存
          if (await setMeasurement()) {
            //ダイヤログの表示off(false)
            setTimeout(() => {
              router.push({
                name: 'selectMenu',
                params: {
                  operator_id: operatorId,
                },
              });
              isComplete.value = false;
              isSaving.value = false;
            },1000);
          }
        }
      } catch (error) {
        isComplete.value = false;
        isSaving.value = false;
        $toast.error(t('patk_error.save_error'), { duration: 5000 });
      }
    };

    // 再測定処理
    const retryMeasure = () => {
      // ページをリロードして再測定を開始
      window.location.reload();
    };

    // 測定準備カウントダウンの処理
    const startPrepCountdown = () => {
      // 測定ステータスを開始状態に変更
      isMeasure.value.isStart = true;

      // 準備時間のカウントダウン処理
      interval = setInterval(() => {
        if (prepCount.value > 1) {
          prepCount.value--;
        } else {
          // 準備時間が終了したら測定中のカウントダウンを開始
          isMeasure.value.isStart = false;
          isMeasure.value.isShow = true;
          clearInterval(interval);

          // 音声測定を開始:1500ms後に録音開始
          // setTimeout(startMeasureCountdown, 1500);
          // setTimeout(runAudioRecord, 1500);
          setTimeout(startMeasureCountdown, 1000);
          setTimeout(runAudioRecord, 1000);
        }
      }, 1000);
    };

    // 測定中カウントダウンの処理
    const startMeasureCountdown = () => {
      // 円形進捗バーと音声録音を開始
      runCircleProgress();
      //runAudioRecord();

      // 測定時間のカウントダウン処理
      interval = setInterval(async () => {
        if (measureCountCounter.value > 1) {
          measureCountCounter.value--;
        } else {
          measureCountCounter.value = 0;
          // 測定終了音声を再生
          measureEndBufferNode.start(0);
          isPlayMeasureAudio = true;
          clearInterval(interval);
          // カウントダウンを完了しステータスを確認
          isCountFinish.value = true;
          measureStatusCheck();
        }
      }, 1000);
    };

    // カウントダウンと音声の録音が完了しているか確認
    const measureStatusCheck = () => {
      // 処理完了フラグを確認する
      if (isCountFinish.value && isAnalyzeAborted.value) {
        // 完了フラグを初期化
        isCountFinish.value = false;
        isAnalyzeAborted.value = false;
        // 測定時間が終了したらステータスを更新
        isMeasure.value.isShow = false;
        isMeasure.value.isEnd = true;

        if(!isError.value){
          //完了ダイヤログの表示(trueへ)
          isComplete.value = true;
          isSaving.value = true;
          //登録処理の実行registMeasureの呼び出し
          registMeasure();
        }

        isMeasure.value.isComplete = true;
      }
    };

    // 円形進捗バーを実行
    const runCircleProgress = () => {
      try {
        // プログレスバーの描画とアニメーション
        const canvas = document.getElementById('progressCanvas');
        if (isMeasure.value.isShow) {
          circleProgress.animate(isMeasure.value.isShow, measureWord, canvas, measureCount.value);
        } else {
          // 測定が開始されていない場合は初期状態のプログレスを描画
          circleProgress.drawProgress(isMeasure.value.isShow, measureWord, canvas, 0);
        }
      } catch (error) {
        console.error('円形進捗バーの実行中にエラーが発生しました:', error);
      }
    };

    // 音声録音を実行
    const runAudioRecord = async () => {
      try {
        // 音声録音の設定
        const audioSettings = {
          recordingTime: measureCount.value * 1000,
          sampleRate: 16000,
          bitDepth: 16,
          channels: 1,
        };
        // 音声録音を開始し、結果を取得
        const recordResult = await startRecording(audioSettings);
        // 音声録音が成功した場合
        if (recordResult && !isAnalyzeAborted.value) {
          // 音声データを更新し、音声解析を実行
          audioData.value = recordResult;
          // 通信中の文言を表示
          isComunicate.value = true;

          await runAudioAnalyze(recordResult);
          // 音声解析を完了しステータスを確認
          isAnalyzeAborted.value = true;
          isComunicate.value = false;

          measureStatusCheck();
        }
      } catch (error) {
        // エラーが発生した場合、エラーメッセージを表示
        isError.value = true;
        errorMessage.value = '⚠' + t('patk_error.recording_error');
      }
    };

    // 音声解析APIを呼び出す
    const runAudioAnalyze = async (audioDataBlob) => {
      try {
        // 音声解析のためのパラメータを設定
        recordedParam.value = {
          filename: audioId.value,
          category: measureWord,
          age: age.value,
          gender: String(gender.value),
          seconds: String(measurementType.value === '1' ? '5' : '10'),
        };

        // 音声データを解析 ※ここで音質解析がある場合はフラグを渡す
        const result = await analyzeRecordedData(audioDataBlob, recordedParam.value, analysisTypeFlag.value,);
        analyzeData.value = result.analyzeData;
        wavDataBase64.value = result.wavDataBase64;

        // console.log('analyzeData.value = ',analyzeData.value);

        // 各発音データに対して処理を行う
        if (analyzeData.value) {
          let measureSeconds = parseInt(measurementType.value === '1' ? 5 : 10);
          analyzeData.value.original_data.forEach((speech) => {
            let second = Math.ceil(speech.from);

            second = Math.max(1, Math.min(measureSeconds, second));
            vocabCountSecond.value[second] = (vocabCountSecond.value[second] || 0) + 1;

            if (speech.dtw_vocab === measureWord) {
              // 質解析
              vocabAnalysisCountSecond.value[second] = (vocabAnalysisCountSecond.value[second] || 0) + 1;
              analysisVocabCount.value = ++analysisVocabCount.value;
            }
          });
          // vocabCountSecond.value内で0がある場合、0.001に変更
          vocabCountSecond.value = vocabCountSecond.value.map((value) => (value === 0 ? 0.001 : value));
          vocabAnalysisCountSecond.value = vocabAnalysisCountSecond.value.map((value) => (value === 0 ? 0.001 : value));
          // グラフで使用しない要素をnullに設定
          const lastIndex = vocabCountSecond.value.length;
          vocabCountSecond.value[0] = null;
          for (let i = measureSeconds + 1; i <= lastIndex; i++) {
            vocabCountSecond.value[i] = null;
          }
          const lastAnalysisIndex = vocabAnalysisCountSecond.value.length;
          vocabAnalysisCountSecond.value[0] = null;
          for (let i = measureSeconds + 1; i <= lastAnalysisIndex ; i++) {
            vocabAnalysisCountSecond.value[i] = null;
          }
        }

      } catch (error) {
        // エラーが発生した場合、エラーメッセージを表示
        isError.value = true;
        errorMessage.value = '⚠' + t('patk_error.analysis_error');
      }
    };

    // S3向け音声保存APIを呼び出す
    const setAudioToS3 = async () => {
      console.log(audioStorageFlag.value, audioStorageFlag.value == 0)
      // 音声保存フラグを確認
      if (audioStorageFlag.value == 0) {
        try {
          const organizationId = store.getters['dataManagement/getOrganizationId'];
          const [datePart] = measureFileData.value.split('_');
          const dirName = `${organizationId}/${operatorId}/${datePart}/audio_data/${subjectId.value}/${audioId.value}`;

          const paramsS3 = {
            Key: `pataka_data/${dirName}`,
            Body: wavDataBase64.value,
          };

          audioURL.value = paramsS3.Key;
          // console.log('S3へアップロード',audioURL.value);

          // 音声データをS3にアップロード
          const result = await store.dispatch('measureExplanation/uploadS3', paramsS3);
          // 登録に失敗した場合エラーメッセージを表示
          if (!result.success) throw new Error(result.error);

        } catch (error) {
          $toast.error(error.message, { duration: 5000 });
          throw new Error();
        }
      }
    };

    // 測定データおよびグラフデータをセットし、検査結果を登録する
    const setMeasurement = async () => {
      try {
        const _date = new Date();

        // 検査終了時刻を取得
        const endDateTime = formatTimeStamp(_date);

        // 測定データをストアにセット
        const measureData = {
          audioId: audioId.value,
          type: measureWord,
          status: t('test_list.status_completed'),
          date: formatDate(_date),
          time: formatTime(_date),
          dateVal: _date.getTime(),
          measurementStartTime: measurementStartTime.value,
          measurementType: measurementType.value,
          isCompleted: true,
        };

        // console.log('measureData',measureData);

        // グラフデータをストアにセット
        const graphData = {
          audioId: audioId.value,
          type: measureWord,
          originalData: analyzeData.value.original_data,
          durationMean: analyzeData.value.summary_data.duration_mean,
          vocabCount: analyzeData.value.summary_data.vocab_count,
          vocabPerSecond: analyzeData.value.summary_data.vocab_per_second,
          vocabCountSecond: vocabCountSecond.value,
          vocabAnalysisCount: analysisVocabCount.value,
          vocabAnalysisCountSecond: vocabAnalysisCountSecond.value,
          duringAnalysisType:analysisTypeFlag.value,
        };

        // 検査結果テーブルのレコードを生成
        const registData = {
          audio_id: audioId.value,
          inspection_id: store.getters['dataManagement/getInspectionId'],
          inspection_start_time: startDateTime.value,
          measurement_start_time: measurementStartTime.value,
          inspection_end_time: endDateTime,
          measurement_type: measurementType.value,
          pronunciation: pronunciation.value,
          original_data: analyzeData.value.original_data,
          duration_mean: analyzeData.value.summary_data.duration_mean,
          vocab_count: analyzeData.value.summary_data.vocab_count,
          analysis_type_flag: analysisTypeFlag.value,
          analysis_vocab_count: analysisVocabCount.value,
          vocab_per_second: analyzeData.value.summary_data.vocab_per_second,
          inspection_audio_url: audioURL.value,
        };

        // ストアにデータをセット
        store.dispatch('dataManagement/setEndDateTime', endDateTime);
        store.dispatch('dataManagement/setGraphData', graphData);
        store.dispatch('dataManagement/setMeasurements', measureData);

        // 各秒ごとの発音回数を登録データに追加
        for (let i = 1; i <= 10; i++) {
          registData[`vocab_count_${i}s`] = vocabCountSecond.value[i];
          registData[`analysis_vocab_count_${i}s`] = vocabAnalysisCountSecond.value[i];
        }

        // 検査結果から質解析用の計算を行う
        let registDataAdd = null;

        if( analysisTypeFlag.value === "2" ){
          registDataAdd = { ...registData, ...calculateDtw(analyzeData.value) };
        } else {
          registDataAdd = registData;
        }

        // console.log('registDataAdd = ',registDataAdd);


        // 検査結果の登録
        const result = await store.dispatch('measureExplanation/regist', registDataAdd);
        // 登録に失敗した場合エラーメッセージを表示
        if (!result.success) throw new Error(result.error);

        // report用のデータを構築
        const reportData ={
          operatorId: store.getters['dataManagement/getOperatorId'],
          subject_id: store.getters['dataManagement/getSubjectId'],
          measurement_type: store.getters['dataManagement/getMeasurementType'],
          analysisTypeFlag: analysisTypeFlag.value,
          gender: gender.value,
          age: age.value,
          measurements: store.getters['dataManagement/getMeasurements'],
          endDateTime: endDateTime,
          grap: store.getters['dataManagement/getGraphData'],
        }

        const report = {
          inspection_id: store.getters['dataManagement/getInspectionId'],
          report_data:reportData,
        }

        // report（DB）に保存
        const endResult = await store.dispatch('measureExplanation/registReport', report);
        if (!endResult.success) throw new Error(endResult.error);

        // report(ストア)保存
        store.dispatch('dataManagement/setMeasurementsData', reportData);
        // store.dispatch('dataManagement/setResultReportData', reportData);

        return true;
      } catch (error) {
        $toast.error(error.message, { duration: 5000 });
        return false;
      }
    };

    return {
      operatorId,
      measurementType,
      audioStorageFlag,
      age,
      gender,
      analysisTypeFlag,
      audioStorageText,
      measureWord,
      measureWordText,
      pronunciation,
      errorMessage,
      isError,
      isMeasure,
      isComunicate,
      isPermission,
      isCountFinish,
      isAnalyzeAborted,
      prepCount,
      measureCount,
      measureCountCounter,
      isSaving,
      isComplete,
      recordedParam,
      audioData,
      vocabCountSecond,
      vocabAnalysisCountSecond,
      audioURL,
      isWideScreen,
      calculateCopyrightClass,
      startMeasure,
      endMeasure,
      registMeasure,
      retryMeasure,
      startPrepCountdown,
      startMeasureCountdown,
      runCircleProgress,
      runAudioRecord,
      useAnalaysisFlag,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/style.scss';

.whole-wrap--measure {
  min-height: 914.88px;
}

.text-copyright-measure {
  position: relative;
  margin-top: 337.38px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  color: #898989;
  font-size: 8px;
  font-family: 'NotoSans-Medium';
  text-align: center;
}

.text-copyright-complete {
  position: relative;
  margin-top: 396.88px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  color: #898989;
  font-size: 8px;
  font-family: 'NotoSans-Medium';
  text-align: center;
}

.measure-subject {
  height: 200px;
  background-repeat: no-repeat;
  background-position: 50%;
  background-image: url('@/assets/img/navy-pa.png');
}

#app.lang-en .measure-subject {
  background-size: 63%;
}

.measure-subject.measure-subject--pa {
  background-image: url('@/assets/img/navy-pa.png');
}

#app.lang-en .measure-subject.measure-subject--pa {
  background-image: url('@/assets/img/en/navy-pa.png');
}

.measure-subject.measure-subject--ta {
  background-image: url('@/assets/img/navy-ta.png');
}

#app.lang-en .measure-subject.measure-subject--ta {
  background-image: url('@/assets/img/en/navy-ta.png');
}

.measure-subject.measure-subject--ka {
  background-image: url('@/assets/img/navy-ka.png');
}

#app.lang-en .measure-subject.measure-subject--ka {
  background-image: url('@/assets/img/en/navy-ka.png');
}

.canvas {
  transform: translate3d(0, 0, 0);
  will-change: transform;
}

.error-text {
  color: red;
  font-weight: bold;
  width: max-content;
  margin-bottom: 30px;
  font-size: 18px;
}
</style>
